import React, { useEffect, useRef, useState } from "react";
import ItemCard from "ui/Card";
import SalesNoteCard from "./SalesNoteCard";
import AccountingSettlementCard from "./AccountingSettelmentCard";
import { useTranslation } from "react-i18next";
import {
	useHomePageAccessStore,
	useUserOrganizationsStore,
	useUserStore,
} from "store";
import LandingNoteCard from "./LandingNoteCard";
import { OrganizationType } from "interface/user";
import InvoiceCard from "./InvoiceCard";
import PurchaseOverviewCard from "./PurchaseOverviewCard";
import YearlyRevenueCard from "./YearlyRevenueCard";
import { getBuyerStatisticApi } from "api/statistic";
import { BuyerStatistic, VesselStatistic } from "interface/statistic";
import { t } from "i18next";
import { formatNorwegianNumber } from "utils/helper";
import ReleasePackageCard from "./ReleasePackageCard";
import { BuyerGuarantee } from "./BuyerGuarantee";
import VesselQuota from "./VesselQuota";

interface HeaderData {
	title: string;
	subTitle: string;
	valueUnit: string;
	currentValue: string;
	changePercent: number;
	isPercentDecrease: boolean;
}
interface HeaderItem {
	registration?: HeaderData;
	quantityPurchased?: HeaderData;
	amountPurchased?: HeaderData;
	catchAmount?: HeaderData;
	totalPaidOut?: HeaderData;
}
const HomePageItems = () => {
	const { user } = useUserStore();
	const [headerItems, setHeaderItems] = useState<HeaderItem>();
	const { defaultOrg } = useUserOrganizationsStore();
	const buyerStatsRef = useRef<BuyerStatistic>();
	const [marginBottom, setMarginBottom] = useState<number>(30);
	const [isMobileView, setIsMobileView] = useState<boolean>(
		window.innerWidth < 768,
	);

	const { homePageAccess, loadHomePageAccess } = useHomePageAccessStore();

	let year = new Date().getFullYear();

	useEffect(() => {
		const handleResize = () => {
			setIsMobileView(window.innerWidth < 768);
		};

		handleResize();
		window.addEventListener("resize", handleResize);
		loadHomePageAccess();

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	useEffect(() => {
		if (!defaultOrg) {
			return;
		}

		//console.log('defaultOrg.type', defaultOrg.type);

		if (defaultOrg.type === OrganizationType.Buyer) {
			getBuyerStatisticApi({
				buyerId: defaultOrg.ledgerAccountNumber?.trim() as any,
				year,
			})
				.then((data) => {
					buyerStatsRef.current = data.data;
					setHeaderItems(
						handleBuyerHeaderItem(defaultOrg.type, data.data, year),
					);
				})
				.catch((err) => {
					console.log(err);
				});
		}

		if (defaultOrg.type === OrganizationType.Terminal) {
			setMarginBottom(0);
		} else if (defaultOrg.type === OrganizationType.Buyer) {
			setMarginBottom(44);
		} else if (defaultOrg.type === OrganizationType.Vessel) {
			setMarginBottom(0);
		}
	}, [defaultOrg, year]);

	if (!user || !defaultOrg) return <div></div>;

	//console.log("homePageAccess", homePageAccess);
	return (
		<div
			style={{
				display: "flex",
				flexDirection: isMobileView ? "column" : "row",
				gap: isMobileView ? 16 : 30,
				height: isMobileView ? "auto" : "100%",
				width: "100%",
			}}
		>
			<div style={{ width: "100%" }}>
				<div
					style={{
						display: "flex",
						flexDirection: isMobileView ? "column" : "row",
						justifyContent: "space-between",
						marginBottom: `${marginBottom}px`,
						width: "100%",
						gap: "30px",
					}}
				>
					{/*{defaultOrg.type === OrganizationType.Vessel && (*/}
					{/*	<>*/}
					{/*		<ItemCard*/}
					{/*			title={headerItems?.registration?.title as any}*/}
					{/*			subTitle={headerItems?.registration?.subTitle as any}*/}
					{/*			currentValue={headerItems?.registration?.currentValue as any}*/}
					{/*			valueUnit={headerItems?.registration?.valueUnit as any}*/}
					{/*			changePercent={headerItems?.registration?.changePercent as any}*/}
					{/*			isPercentDecrease={*/}
					{/*				headerItems?.registration?.isPercentDecrease as any*/}
					{/*			}*/}
					{/*			style={{ width: "100%" }}*/}
					{/*		/>*/}
					{/*		<ItemCard*/}
					{/*			title={headerItems?.catchAmount?.title as any}*/}
					{/*			subTitle={headerItems?.catchAmount?.subTitle as any}*/}
					{/*			currentValue={headerItems?.catchAmount?.currentValue as any}*/}
					{/*			valueUnit={headerItems?.catchAmount?.valueUnit as any}*/}
					{/*			changePercent={headerItems?.catchAmount?.changePercent as any}*/}
					{/*			isPercentDecrease={*/}
					{/*				headerItems?.catchAmount?.isPercentDecrease as any*/}
					{/*			}*/}
					{/*			style={{ width: "100%" }}*/}
					{/*		/>*/}
					{/*	</>*/}
					{/*)}*/}
					{defaultOrg.type === OrganizationType.Buyer && (
						<>
							<ItemCard
								title={headerItems?.quantityPurchased?.title as any}
								subTitle={headerItems?.quantityPurchased?.subTitle as any}
								currentValue={
									headerItems?.quantityPurchased?.currentValue as any
								}
								valueUnit={headerItems?.quantityPurchased?.valueUnit as any}
								changePercent={
									headerItems?.quantityPurchased?.changePercent as any
								}
								isPercentDecrease={
									headerItems?.quantityPurchased?.isPercentDecrease as any
								}
								style={{ width: "100%" }}
							/>
							<ItemCard
								title={headerItems?.amountPurchased?.title as any}
								subTitle={headerItems?.amountPurchased?.subTitle as any}
								currentValue={headerItems?.amountPurchased?.currentValue as any}
								valueUnit={headerItems?.amountPurchased?.valueUnit as any}
								changePercent={
									headerItems?.amountPurchased?.changePercent as any
								}
								isPercentDecrease={
									headerItems?.amountPurchased?.isPercentDecrease as any
								}
								style={{ width: "100%" }}
							/>
							<div style={{ width: "100%" }}>
								<BuyerGuarantee
									availableBalance={buyerStatsRef.current?.availableBalance}
									balance={buyerStatsRef.current?.balance}
									availableBalancePercentage={
										buyerStatsRef.current?.availableBalancePercentage
									}
								/>
							</div>
						</>
					)}
				</div>

				<div
					style={{
						display: "flex",
						flexDirection: "column",
						gap: "30px",
						paddingBottom: "50px",
					}}
				>
					{defaultOrg.type === OrganizationType.Buyer && (
						<>
							<div>
								<PurchaseOverviewCard
									buyerLedgerAccountNumber={defaultOrg.ledgerAccountNumber}
									isMobileView={isMobileView}
								/>
							</div>
							{homePageAccess?.salesNote?.read && (
								<div className="border-radius">
									<SalesNoteCard isMobileView={isMobileView} />
								</div>
							)}
							<div>
								<InvoiceCard
									isMobileView={isMobileView}
									buyerLedgerAccountNumber={defaultOrg.ledgerAccountNumber}
								/>
							</div>
						</>
					)}
					{defaultOrg.type === OrganizationType.Vessel && (
						<>
							<div>
								<VesselQuota isMobileView={isMobileView} />
							</div>
							{homePageAccess?.landingNote?.read && (
								<div className="border-radius">
									<LandingNoteCard isMobileView={isMobileView} />
								</div>
							)}
							{homePageAccess?.salesNote?.read && (
								<div className="border-radius">
									<SalesNoteCard isMobileView={isMobileView} />
								</div>
							)}
							<div className="border-radius">
								<AccountingSettlementCard isMobileView={isMobileView} />
							</div>
							<div className="border-radius">
								<YearlyRevenueCard isMobileView={isMobileView} />
							</div>{" "}
						</>
					)}
					{defaultOrg.type === OrganizationType.Terminal && (
						<>
							{homePageAccess?.landingNote?.read && (
								<div className="border-radius">
									<LandingNoteCard isMobileView={isMobileView} />
								</div>
							)}
							<div className="border-radius">
								<ReleasePackageCard isMobileView={isMobileView} />
							</div>
						</>
					)}
				</div>
			</div>
		</div>
	);
};

export default HomePageItems;

const handleBuyerHeaderItem = (
	type: OrganizationType,
	data: BuyerStatistic,
	year: number,
): HeaderItem => {
	const _data: HeaderItem = {};
	if (type === OrganizationType.Buyer) {
		_data.quantityPurchased = {
			currentValue: formatNorwegianNumber(data.totalLiveWeightKg),
			changePercent: toDecimal(data.totalLiveWeightKgPercentageDifference),
			title: "Kvantum kjøpt i " + year,
			subTitle: "sammenlignet med samme periode fjoråret",
			isPercentDecrease:
				data.totalLiveWeightKg < data.lastYearTotalLiveWeightKg,
			valueUnit: "Kg",
		};
		_data.amountPurchased = {
			currentValue: formatNorwegianNumber(data.totalBuyerAmount) as any,
			changePercent: toDecimal(data.totalBuyerAmountPercentageDifference),
			title: "Beløp kjøpt for  i " + year,
			subTitle: "sammenlignet med samme periode fjoråret",
			isPercentDecrease: data.totalBuyerAmount < data.lastYearTotalBuyerAmount,
			valueUnit: "Kr",
		};
	}
	return _data;
};

const handleVesselHeaderItem = (
	data: VesselStatistic,
	year: number,
): HeaderItem => {
	const _data: HeaderItem = {};
	_data.registration = {
		currentValue: formatNorwegianNumber(data?.totalLiveWeightKg),
		changePercent: toDecimal(data.totalLiveWeightKgPercentageDifference),
		title: t("RegisteredSoFarIn") + " " + year,
		subTitle: t("ComparedToLastYear"),
		isPercentDecrease: data.totalLiveWeightKg < data.lastYearTotalLiveWeightKg,
		valueUnit: "Kg",
	};

	_data.catchAmount = {
		currentValue: formatNorwegianNumber(data.totalFishermanAmount),
		changePercent: toDecimal(data.totalFishermanAmountPercentageDifference),
		title: "Fangstverdi hittl i år " + year,
		subTitle: t("ComparedToLastYear"),
		isPercentDecrease:
			data.totalFishermanAmount < data.lastYearTotalFishermanAmount,
		valueUnit: "Kr",
	};

	return _data;
};

function toDecimal(num: number, point: number = 2) {
	if (num == null || num === undefined) {
		return 0;
	}
	return parseFloat(num.toFixed(point));
}
